module.exports = __webpack_public_path__ + "media/lots.066d70b1.jpg";